<template>
  <div>
    <ca-row>
      <ca-col size="2">
        <ca-button full-width @click="onEdit">Editar</ca-button>
      </ca-col>
    </ca-row>

    <ca-row vertical-offset="2">
      <ca-col>
        <ca-page>
          <ca-loader v-if="showLoading"></ca-loader>

          <template v-else>
            <ca-row>
              <ca-col size="4">
                <ca-field :label="getInscriptionLabel(establishment.registrationType.name)">
                </ca-field>
                {{ establishment.registration }}
              </ca-col>
              <ca-col size="4">
                <ca-field label="CNAE Preponderante">
                  {{ establishment.preponderantCnae }}
                </ca-field>
              </ca-col>
            </ca-row>

            <ca-row v-if="isLegalInscription" vertical-offset="2">
              <ca-col size="4">
                <ca-field label="Alíquota RAT">
                  {{ establishment.ratAliquot }}
                </ca-field>
              </ca-col>
              <ca-col size="4">
                <ca-field label="FAP">
                  {{ establishment.fap }}
                </ca-field>
              </ca-col>
            </ca-row>

            <ca-row v-if="isLegalInscription">
              <ca-col size="4">
                <ca-field label="Tipo de CAEPF">
                  {{ establishment.naturalPersonCaeType.description }}
                </ca-field>
              </ca-col>
              <ca-col size="4">
                <ca-field label="CEI para SEFIP">
                  {{ establishment.ceiSefip }}
                </ca-field>
              </ca-col>
              <ca-col size="4">
                <ca-field label="Opção de Registro de Ponto">
                  {{ establishment.electronicPointType.description }}
                </ca-field>
              </ca-col>
            </ca-row>

            <ca-row vertical-offset="2">
              <ca-col size="4">
                <ca-field label="Contratação de Aprendiz">
                  {{ establishment.apprenticeContracting.description }}
                </ca-field>
              </ca-col>
              <ca-col size="4">
                <ca-field label="Endereço">
                  {{ address }}
                </ca-field>
              </ca-col>
              <ca-col size="4">
                <ca-field label="Registro Eletrônico de Empregados">
                  {{ establishment.indElectronicEmployeeRegistry ? 'Sim' : 'Não' }}
                </ca-field>
              </ca-col>
            </ca-row>

            <ca-row vertical-offset="2">
              <ca-col v-if="isLegalInscription" size="4">
                <ca-field label="Cidade">
                  {{ `${establishment.city} - ${establishment.state.description}` }}
                </ca-field>
              </ca-col>
              <ca-col v-if="isLegalInscription" size="4">
                <ca-field label="Telefone">
                  {{ establishment.phone }}
                </ca-field>
              </ca-col>
              <ca-col size="4">
                <ca-field label="Denominação">
                  {{ establishment.denomination }}
                </ca-field>
              </ca-col>
            </ca-row>

            <ca-row>
              <ca-col size="4">
                <ca-field label="Situação no eSocial">
                  {{ establishment.statusEsocial.description }}
                </ca-field>
              </ca-col>
              <ca-col v-if="showESocialChangeDate" size="4">
                <ca-field label="Data de alteração">
                  {{ establishment.esocialChangeDate | caDate }}
                </ca-field>
              </ca-col>
            </ca-row>

            <ca-row vertical-offset="2">
              <ca-col v-if="establishment.apprenticeContracting.name != 'N'" size="4">
                <ca-field
                  label="Realiza a contratação de aprendiz por intermédio
                        de entidade educativa sem fins lucrativos">
                  {{ establishment.contEntEdu ? 'Sim' : 'Não' }}
                </ca-field>
              </ca-col>
              <ca-col size="4">
                <ca-field label="Desoneração da Folha">
                  {{ establishment.indContPatObra ? 'Sim' : 'Não' }}
                </ca-field>
              </ca-col>
            </ca-row>
          </template>
        </ca-page>
      </ca-col>
    </ca-row>
  </div>
</template>

<script>
import { getEstablishment, getInscriptionLabel, setEstablishment } from './establishmentService';
import { EmployerStore } from '../store';

export default {
  name: 'EstablishmentViewPage',
  computed: {
    isLegalInscription() {
      return this.establishment.registrationType.name === 'J';
    },
    address() {
      return `${this.establishment.address}, ${this.establishment.number}, ${this.establishment.zipCode}`;
    },
    establishment() {
      return EmployerStore.establishment;
    },
    showLoading() {
      return !this.establishment;
    },
    showESocialChangeDate() {
      return this.establishment.statusEsocial.name === 'A';
    },
  },
  created() {
    this.setEstablishment();
  },
  methods: {
    getInscriptionLabel,
    async setEstablishment() {
      const response = await getEstablishment();
      setEstablishment(response);
    },
    onEdit() {
      this.$router.push({ name: 'EditEstablishment' });
    },
  },
};
</script>
